import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { getDatefromWeekNum0, myAxios, MyDate, weeknum } from "src/components/common/functions";
import type { PayrollAssignment } from "src/components/payroll/payroll";

export type HoursAssignment = PayrollAssignment & {
    assignmentId: string;
    workId: string;
    projectId: string;
    projectName: string;
};

export type HoursLoaderData = {
    assignments: HoursAssignment[];
    week: string;
    weeks: string[];
};

function buildWeeks(minTime?: string | null, maxTime?: string | null): string[] {
    if (!minTime || !maxTime) return [];
    const weeks: string[] = [];
    const dateMin = new Date(String(minTime).replace(/-/g, "/"));
    const dateMax = new Date(String(maxTime).replace(/-/g, "/"));
    while (dateMin < dateMax) {
        weeks.push(weeknum(dateMin));
        dateMin.setDate(dateMin.getDate() + 7);
    }
    const lastWeek = weeknum(dateMax);
    if (!weeks.includes(lastWeek)) {
        weeks.push(lastWeek);
    }
    return weeks.sort((a, b) => (a < b ? 1 : -1));
}

export async function hoursLoader({ params }: LoaderFunctionArgs): Promise<HoursLoaderData> {
    const rangeRes = await myAxios({ fileName: "hours/readWeeks.php" });
    if (!rangeRes) throw redirect("..");

    const weeks = buildWeeks(rangeRes.data?.minTime, rangeRes.data?.maxTime);
    const fallbackWeek = weeks[0] ?? weeknum(new MyDate());
    const week = params.week ?? fallbackWeek;

    if (!params.week) {
        throw redirect(`/Hours/${week}`);
    }
    if (weeks.length && !weeks.includes(week)) {
        throw redirect(`/Hours/${fallbackWeek}`);
    }

    const formData = new FormData();
    formData.append(
        "weekStart",
        getDatefromWeekNum0(week, 0)?.toLocaleDateString("fr-CA", { timeZone: "America/Los_Angeles" }) ?? ""
    );
    formData.append(
        "weekEnd",
        getDatefromWeekNum0(week, 7)?.toLocaleDateString("fr-CA", { timeZone: "America/Los_Angeles" }) ?? ""
    );

    const assignmentsRes = await myAxios({
        fileName: "hours/readAssignments.php",
        formData,
    });
    if (!assignmentsRes) throw redirect("..");

    const resolvedWeeks = weeks.includes(week) ? weeks : [week, ...weeks];
    return {
        assignments: Array.isArray(assignmentsRes.data) ? (assignmentsRes.data as HoursAssignment[]) : [],
        week,
        weeks: resolvedWeeks,
    };
}
